"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeSerializeObjRef = void 0;
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * Wrapper around {@link @gooddata/sdk-model#serializeObjRef} that can handle undefined values.
 *
 * @param ref - ref to serialize
 */
function safeSerializeObjRef(ref) {
    return ref ? sdk_model_1.serializeObjRef(ref) : "";
}
exports.safeSerializeObjRef = safeSerializeObjRef;
//# sourceMappingURL=safeSerializeObjRef.js.map